import React from 'react';

const SendRetryBox = () => {
  return (
    <div className="px-[15px] py-[5px] flex items-center my-[5px] w-fit">
      <span className="text-[12px] text-red-300">The AI service disconnected. Try again.</span>
      <button className="border border-primary rounded-[6px] leading-none px-[5px] py-[3px] text-primary text-[12px] ml-2 hover:bg-second">Retry</button>
    </div>
  );
};

export default SendRetryBox;